import React from 'react'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'
import { PuzzleHome, PuzzleRegister, PuzzleViewer, PuzzleMenu } from '.'
import { CustomizedSnackbar } from '../../../containers'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import { LANGUAGE_SHORT_CODE } from '../../../constants';
import Word from '../../../containers/Common/Word';
import { WID } from '../../../constants/Language';

const urlPropsQueryConfig_PuzzleViewer = {
  v: { type: UrlQueryParamTypes.number },
  md: { type: UrlQueryParamTypes.string },
  op: { type: UrlQueryParamTypes.string },
  mv: { type: UrlQueryParamTypes.string },
  pb: { type: UrlQueryParamTypes.string },
  pw: { type: UrlQueryParamTypes.string },
  tr: { type: UrlQueryParamTypes.string },
  mk: { type: UrlQueryParamTypes.string },
  pt: { type: UrlQueryParamTypes.string },
  lv: { type: UrlQueryParamTypes.number },
  moves: { type: UrlQueryParamTypes.string },
}

class PuzzleRouting extends React.Component {
  render() {
    var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

    return (
      <React.Fragment>
        <MenuAppBar title={<Word wid={WID.MENU_APP_BAR.PUZZLE}/>} actions={<PuzzleMenu/>}/>
        <Switch>
          <Route exact path={`/:language(${regstr})/puzzle`} component={PuzzleHome}/>
          <Route path={`/:language(${regstr})/puzzle/register/:id`} component={PuzzleRegister}/>
          <Route path={`/:language(${regstr})/puzzle/register`} component={PuzzleRegister}/>
          <Route path={`/:language(${regstr})/puzzle/:id`} component={addUrlProps({ urlPropsQueryConfig_PuzzleViewer })(PuzzleViewer)}/>

          <Route exact path='/puzzle' component={PuzzleHome} />
          <Route path='/puzzle/register/:id' component={PuzzleRegister} />
          <Route path='/puzzle/register' component={PuzzleRegister} />
          <Route path='/puzzle/:id' component={addUrlProps({ urlPropsQueryConfig_PuzzleViewer })(PuzzleViewer)} />
        </Switch>
        <CustomizedSnackbar/>
      </React.Fragment>
    )
  }
}

export default (PuzzleRouting)



// WEBPACK FOOTER //
// ./src/Pages/Puzzle/containers/PuzzleRouting.js